import { render } from "./RecordingShow.vue?vue&type=template&id=4b95a236&scoped=true"
import script from "./RecordingShow.vue?vue&type=script&lang=js"
export * from "./RecordingShow.vue?vue&type=script&lang=js"

import "./RecordingShow.vue?vue&type=style&index=0&id=4b95a236&lang=scss"
import "./RecordingShow.vue?vue&type=style&index=1&id=4b95a236&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b95a236"]])

export default __exports__